import { useSelector } from 'react-redux';
import styles from './UserProfile.module.css';

const UserProfile = () => {
  const role = useSelector((state) => state.auth.role);
  const email = useSelector((state) => state.auth.email);
  const athleteProfile = useSelector((state) => state.athlete.profile);
  const coachProfile = useSelector((state) => state.coach.profile);

  const profile = role === 'athlete' ? athleteProfile : role === 'coach' ? coachProfile : null;

  if (!profile) return null; 

  return (
    <div className={styles.userProfile}>
      <img
        src={profile.profilePicture || '/images/avatar-boy-svgrepo-com.svg'}
        alt="User avatar"
        className={styles.avatar}
      />
      <div className={styles.userInfo}>
        <span className={styles.name}>
          {profile.firstName} {profile.lastName}
        </span>
        <span className={styles.email}>
          {email}
        </span>
      </div>
    </div>
  );
};

export default UserProfile;